import { render, staticRenderFns } from "./ArtistPage.vue?vue&type=template&id=b2f89576&"
import script from "./ArtistPage.vue?vue&type=script&lang=js&"
export * from "./ArtistPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports